import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import history from '~/services/history';
import apiBearer from '~/services/apiBearer';

import { updateProfileSuccess, getDataProfileResponse } from './actions';
import { signOut } from '../auth/actions';

export function* changePassword({ payload }) {
  try {
    const { token } = payload;
    const { password, newPassword, confirmNewPassword } = payload.data;

    if (!token) return;

    apiBearer.defaults.headers.Authorization = `Bearer ${token}`;
    const response = yield call(apiBearer.post, 'api/v1/WSAlterarSenha', {
      senhaAtual: password,
      novaSenha: newPassword,
      confirmacaoDeSenha: confirmNewPassword,
    });

    const { sucesso, mensagem } = response.data;

    if (mensagem.includes('Token inválido.')) {
      return yield put(signOut());
    }

    if (!sucesso) {
      toast.error(`Erro: ${mensagem}`);
    }

    if (mensagem.includes('Senha alterada com sucesso')) {
      history.push('/AlterarSenhaSucesso', { reload: true });
    }

    // yield put(changePasswordResponse({ data: conteudo }));
    // history.push('/AlterarSenhaSucesso', { reload: true });
  } catch (error) {
    toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    console.error(error);
  }
}

export function* updateProfile({ payload }) {
  try {
    const { token, data } = payload;

    if (!token) return;

    apiBearer.defaults.headers.Authorization = `Bearer ${token}`;
    const response = yield call(apiBearer.post, 'api/v1/WSAtualizaDados', data);

    const { sucesso, mensagem, conteudo } = response.data;

    if (!sucesso) {
      toast.error(`Erro: ${mensagem}`);
    }

    yield put(updateProfileSuccess({ data: conteudo }));
    history.push('/AtualizarDadosSucesso', { reload: true });
  } catch (error) {
    toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    console.error(error);
  }
}

export function* getDataProfile({ payload }) {
  try {
    const { token } = payload;

    if (!token) return;

    apiBearer.defaults.headers.Authorization = `Bearer ${token}`;
    const response = yield call(apiBearer.get, 'api/v1/WSAtualizaDados');

    const { sucesso, mensagem, conteudo } = response.data;

    if (!sucesso) {
      toast.error(`Erro: ${mensagem}`);
    }

    yield put(getDataProfileResponse({ conteudo }));
  } catch (error) {
    toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    console.error(error);
  }
}

export default all([
  takeLatest('@user/UPDATE_PROFILE_REQUEST', updateProfile),
  takeLatest('@user/GET_DATA_PROFILE_REQUEST', getDataProfile),
  takeLatest('@user/CHANGE_PASSWORD_REQUEST', changePassword),
]);
